import React from 'react';

type Props = {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
};

function CardHeader({ title, subtitle, children }: Props) {
  if (children && title) {
    throw Error('Specify either title or children!');
  }

  if (title) {
    return (
      <div className="card-header border-b border-gray-200 px-4 py-5 font-medium sm:px-6">
        <div className="leading-6">{title}</div>
        {subtitle && <div className="mt-1 text-sm font-normal text-gray-500">{subtitle}</div>}
      </div>
    );
  }

  return <div className="card-header border-b border-gray-200 px-4 py-5 font-medium sm:px-6">{children}</div>;
}

export default CardHeader;
